import React from "react";
import { Box, Chip, Stack, useTheme } from "@mui/material";
import MuCard, { CardProps as MuCardProps } from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

export type CardProps = MuCardProps & {
  cardtitle?: string;
  cardtext?: string;
  cardicon?: React.ReactNode;
  cardbutton?: React.ReactNode;
  chiptext?: string;
};

const AppCard = ({ ...others }: CardProps) => {
  const theme = useTheme();
  return (
    <MuCard
      variant="outlined"
      sx={{
        width: "266px",
        borderRadius: "8px",
        borderColor: theme.palette.primary.light,
      }}
      {...others}>
      <CardContent
        sx={{
          height: "100%",
          paddingBottom: "16px !important",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          flexDirection: "column",
        }}>
        <Box>
          <Stack
            sx={{
              height: "70px",
              justifyContent: "center",
            }}>
            {others.cardicon}
          </Stack>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "24px",
              display: "inline-flex",
              mr: 1,
            }}
            color="text.primary">
            {others.cardtitle || "Untitled"}
          </Typography>
          {others.chiptext && (
            <Chip
              label={others.chiptext}
              color="info"
              sx={{
                width: "auto",
                maxHeight: "22px",
                padding: "2px 8px",
                marginBottom: "4px",
                fontWeight: 500,
                "& .MuiChip-label": {
                  fontSize: "14px !important",
                },
              }}
            />
          )}
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              color: theme.palette.text.secondary,
              lineHeight: "20px",
            }}>
            {others.cardtext || "Text goes here"}
          </Typography>
        </Box>
        <CardActions sx={{ marginTop: "8px", padding: "0px" }}>{others.cardbutton}</CardActions>
      </CardContent>
    </MuCard>
  );
};

export default AppCard;
